var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M9.986 22.238a8.368 8.368 0 0 1-2.147-3.08c-1.227-3.017-.652-6.604 1.743-9.079l2.21 2.216c.123.122.342.034.371-.146l1.208-7.922a.197.197 0 0 0-.224-.225l-7.908 1.21c-.18.03-.268.25-.146.372l2.215 2.22c-3.657 3.75-4.28 9.372-1.88 13.765a11.708 11.708 0 0 0 2.99 3.549c2.163 1.723 4.821 2.548 7.46 2.494l.497-3.256c-2.274.196-4.611-.507-6.389-2.118Zm14.706 1.955c3.657-3.749 4.28-9.372 1.88-13.765a11.706 11.706 0 0 0-2.99-3.548c-2.163-1.724-4.821-2.548-7.46-2.495l-.497 3.256c2.27-.195 4.611.508 6.389 2.118a8.368 8.368 0 0 1 2.147 3.08c1.227 3.017.652 6.604-1.743 9.08l-2.211-2.217c-.122-.122-.34-.034-.37.146l-1.208 7.922a.197.197 0 0 0 .224.225l7.908-1.21c.18-.03.263-.25.146-.371l-2.215-2.221Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.4a7e1b72c3247c1ad48c3885580dbe77.svg";
export { ForwardRef as ReactComponent };